export default __webpack_public_path__ + "static/media/course1.a16340ef.png";